import { useAtom } from 'jotai'
import { useCallback } from 'react'

import { shiftKeyIsPressedAtom } from '../keyManager/keyManager.store'

/** Jotai-backed shift / key UI state. Import only this hook from feature code. */
export function useKeyManagerStore() {
    const [shiftKeyIsPressed, setShiftKeyIsPressed] = useAtom(shiftKeyIsPressedAtom)

    const setShiftKeyPressed = useCallback(
        (value: boolean) => {
            setShiftKeyIsPressed(value)
        },
        [setShiftKeyIsPressed],
    )

    return { shiftKeyIsPressed, setShiftKeyPressed }
}
